import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import {
  ConnectWallet,
  useWalletAddress,
  useActiveConnector,
} from "features/auth";
import { H1 } from "atoms";
import { MintMembershipPass } from "features/corporate";
import { Head } from "features/misc";
import hammerSVG from "assets/images/hammer.svg";
import mintingIsLiveSVG from "assets/images/minting-is-now-live.svg";
import { useMintEnabled } from "utils/mintHelpers";

function Mint() {
  const { mintEnabled, isLoading } = useMintEnabled();
  const walletAddress = useWalletAddress();
  const connector = useActiveConnector();
  const walletProvider = connector?.provider;

  if (isLoading) {
    return null;
  }

  if (!mintEnabled) {
    return (
      <NotReady>
        <Head title="Mint" />

        <HammerImg
          src={hammerSVG}
          alt=""
          aria-hidden="true"
          role="presentation"
          animate={false}
        />
        <H1>Minting is closed</H1>
      </NotReady>
    );
  }

  if (!walletAddress || !walletProvider) {
    return (
      <ConnectWallet>
        <Head title="Mint" />

        <HammerImg
          src={hammerSVG}
          alt=""
          aria-hidden="true"
          role="presentation"
        />
        <MainImg src={mintingIsLiveSVG} alt="Minting Is Now Live!" />
      </ConnectWallet>
    );
  }

  return (
    <>
      <Head title="Mint" />

      <MintMembershipPass />
    </>
  );
}

const hammerAnimation = keyframes({
  "from, 15%, 55%, 80%, to": {
    transform: "rotate(0deg)",
  },
  "40%, 45%": {
    transform: "rotate(45deg)",
  },
  "70%": {
    transform: "rotate(8deg)",
  },
  "90%": {
    transform: "rotate(2deg)",
  },
});

const HammerImg = styled.img<{ animate?: boolean }>(
  {
    marginBottom: "1rem",
    width: "30%",
  },
  ({ animate = true }) => ({
    "@media (prefers-reduced-motion: no-preference)": {
      animation: `${hammerAnimation} 1.5s ease ${animate ? "infinite" : ""}`,
      transformOrigin: "bottom right",
    },
  })
);

const MainImg = styled.img({
  marginBottom: "3rem",
  width: "100%",
});

const NotReady = styled.div({
  maxWidth: 500,
  margin: "0 auto",
  textAlign: "center",
});

export { Mint };
